
export default {
  props: {
    block: {
      type: Object,
      required: true,
    },
    light: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    image () {
      let image = null;
      if (this.block.hero_image) {
        image = this.block.hero_image;
      }

      return {
        src: image ? image.url : this.$store.state.config.default_page_image[this.imageSize],
        srcset: image.sizes[`2048x2048`] || ``,
        alt: image.title || this.title,
      };
    },
    isDark () {
      return !!(this.block.background === `bg-grey500` || this.block.background === `bg-primary` || this.block.background === `bg-secondary`);
    },
  },
};
